<template>
  <div class="x-userdetails">
    <!-- <div class="x-userdetails-title">未完成</div>
    <el-table :data="tableData" height="250" border style="width: 100%">
      <el-table-column prop="usertitle" label="任务名称" width="180">
        <template slot-scope="scope">{{scope.row.title}}</template>
      </el-table-column>
      <el-table-column prop="userstudy" label="学习进度" width="180">
        <template slot-scope="scope">{{scope.row.study_progress*2}} %</template>
      </el-table-column>
      <el-table-column prop="userexat" label="考试进度">
        <template slot-scope="scope">{{scope.row.exam_prigress*2}} %</template>
      </el-table-column>
      <el-table-column prop="userall" label="总进度">
        <template slot-scope="scope">{{scope.row.study_progress+scope.row.exam_prigress}} %</template>
      </el-table-column>
    </el-table>
    <div class="x-userdetails-title x-userdetails-titletwo">已完成</div>
    <el-table :data="tableDataTwo" height="250" border style="width: 100%">
      <el-table-column prop="usertitle" label="任务名称" width="180">
        <template slot-scope="scope">{{scope.row.title}}</template>
      </el-table-column>
      <el-table-column prop="userstudy" label="学习进度" width="180">
        <template slot-scope="scope">{{scope.row.study_progress*2}} %</template>
      </el-table-column>
      <el-table-column prop="userexat" label="考试进度">
        <template slot-scope="scope">{{scope.row.exam_prigress*2}} %</template>
      </el-table-column>
      <el-table-column prop="userall" label="总进度">
        <template slot-scope="scope">{{scope.row.study_progress+scope.row.exam_prigress}} %</template>
      </el-table-column>
    </el-table> -->
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" class="x-userdetail-left">
        <div class="grid-content bg-purple">
          <div class="x-userdetail-tt">{{username}}的任务列表</div>
          <ul>
            <li v-for="item in dataleft" :key="item.id" @click="changegroup(item.id,item.title)">{{item.title}}</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="16" class="x-userdetail-right">
        <div class="grid-content bg-purple-light">
          <div class="x-per-right">

            <div class="x-all-btn">
              <div class="x-btn-left">{{usertitle}}</div>
            </div>

            <el-table :data="tableData">
              <el-table-column label="课程名称" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column label="学习时长" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.study_time }}</span>
                </template>
              </el-table-column>
              <el-table-column label="考试分数" width="">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.score }}</span>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "userdetails",
  data(){
    return{
      userid:'',
      tableData:[],
      tableDataTwo:[],
      dataleft:'',
      usertitle:'',
      rightlistfirstid:'',
      username:''
    }
  },
  created(){
    console.log('学员id:'+this.$route.params.userid);
    console.log('学员名字:'+this.$route.params.username);
    this.userid = this.$route.params.userid;
    this.username = this.$route.params.username;
    this.seeuser(this.userid)
  },
  methods:{
    // 学员信息
    seeuser(id){
      console.log(id);
      axios.get('/learn/task/memberTask', {
        params: {
          sec: localStorage.token,
          memberId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.dataleft = response.data.data.list;
            this.rightlistfirstid = response.data.data.list[0].id;//第一个组织的id
            this.usertitle = response.data.data.list[0].title;//第一个组织的title
            this.userfinishlist()
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 对应列表
    changegroup(groupid,grouptitle,groupcount){
      this.rightlistfirstid = groupid;
      this.usertitle = grouptitle
      this.userfinishlist()
    },
    // 学员列表 角色
    userfinishlist(){
      console.log(this.rightlistfirstid);
      axios.get('/learn/task/memberTaskDetail', {
        params: {
          sec: localStorage.token,
          memberId:this.userid,
          taskId:this.rightlistfirstid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.tableData = response.data.data.list;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>
<style>
.x-userdetails .el-table th{
  background-color: #F2F2F2;
}
.x-userdetails .el-table th ,.x-userdetails .el-table td{
  text-align: center;
}.x-userdetails .x-userdetails-title{
  margin: 20px auto;
  background-color: #F2F2F2;
  width: 120px;
  text-align: center;
  line-height: 34px;
  height: 34px;
  color: #999;
  font-size: 14px;
  border-radius: 5px;
}.x-userdetails .x-userdetails-titletwo{
  background-color: #BDA17A;
  color: #fff;
}.x-userdetails{
  background-color: #f5f5f5;
}.el-main{
  /* padding: 0; */
}.x-userdetail-left {
  height: 740px;
  position: relative;
  margin: 20px 10px;
  background-color: #fff;
  overflow-y: scroll;
}.x-userdetail-left .x-userdetail-tt,.x-userdetail-left li{
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
}.x-userdetail-left li{
  cursor: pointer;
}.x-per-right{
  background-color: #fff;
}.x-userdetail-right{
  margin: 20px 10px;
  background-color: #fff;
}.x-userdetail-right .el-table{
  margin: 40px;
  width: auto;
}.x-btn-left{
  padding: 20px 40px;
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/userdetails.vue